module.exports = __webpack_public_path__ + "static/img/increase_budget_active.f52985b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/increase_budget_active.png
// module id = Z12J
// module chunks = 101